
























import { Stats } from "@/types/stats";
import { Features } from "@/types/settings";
import { Component, Vue } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

@Component
export default class OverviewConnections extends Vue {
  @State(state => state.stats.stats) stats!: Stats;

  @Getter("settings/activeCacheFeatures") features!: Features;
  @Getter("processedStats/statLastHour") statLastHour!: (chartID: string, statName: string) => number | null | false;

  get connectionsLastHour() {
    return this.statLastHour("connections", "connection_rate");
  }

  get historicalConnections() {
    if (this.features["collect-granularity"] !== 0) {
      const conns = this.connectionsLastHour;
      if ((conns === 0 || conns) && typeof conns === "number") {
        return `${conns.toFixed(2)}/s`;
      }
      return conns;
    }
    return this.stats.total_connections as number;
  }

  get historicalConnectionsLabel() {
    if (this.features["collect-granularity"] !== 0) {
      return "new connections last hour";
    }
    return "all time connections";
  }

  get issue() {
    if (this.features["collect-granularity"] !== 0 && this.connectionsLastHour && this.connectionsLastHour > 10) {
      return "New connections are high! Consider using permanent connections to consume fewer resources.";
    }
    // Analytics only
    if (this.features["collect-granularity"] === 0 && this.stats.curr_connections > 10) {
      return "Only 10 active connections are included in our Developer plan!";
    }
    return "";
  }
}
